import React from 'react'
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import OrderDetails from "../../components/Delivery/OrderDetails/OrderDetails";

const HomePage = () => {
  return (
    <div>
        <Header activeHeading={2} />
        <OrderDetails />
        <Footer />
    </div>
  )
}

export default HomePage